import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { exploreColumnSchema } from './explore-column';

export type PresetId = Preset['id'];

export type Preset = z.output<typeof presetSchema>;
export type PresetDTO = z.input<typeof presetSchema>;

export const presetSchema = z.object({
  columns: z.array(exploreColumnSchema),
  createdAt: isoDatetimeToDate,
  id: z.uuid(),
  name: z.string(),
  updatedAt: isoDatetimeToDate,
});
